/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PlanSettingsExclusionRulesType from '@jira/spa-apps__advanced-roadmaps-plan-settings/src/ExclusionRulesPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - exclusion-rules page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsExclusionRules: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof PlanSettingsExclusionRulesType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-plan-settings-exclusion-rules", jiraSpaEntry: "async-plan-settings-plan-settings-exclusion-rules" */ '@jira/spa-apps__advanced-roadmaps-plan-settings/src/ExclusionRulesPage.tsx'
			),
		),
	{ ssr: false },
);

const AsyncPlanSettingsExclusionRules = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsExclusionRules}
		pageId="plan-settings-exclusion-rules"
		shouldShowSpinner
	/>
);

export default AsyncPlanSettingsExclusionRules;
